import React from 'react';
import { Progress, Space, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface ProgressDisplayProps {
  percent?: number;
  stage?: string;
  message?: string;
  studentName?: string;
}

// 获取阶段的中文名称
const getStageName = (stage?: string): string => {
  const stageMap: Record<string, string> = {
    upload: '上传文件',
    ocr: 'OCR识别',
    analyzing: 'AI分析',
    generating: '生成批改',
    completed: '完成',
  };
  return stageMap[stage || ''] || '处理中';
};

// 获取阶段的详细描述
const getStageDescription = (stage?: string, studentName?: string): string => {
  const prefix = studentName ? `${studentName}：` : '';
  
  switch (stage) {
    case 'upload':
      return `${prefix}正在上传作文文件...`;
    case 'ocr':
      return `${prefix}正在识别手写文字...`;
    case 'analyzing':
      return `${prefix}AI正在分析作文结构和内容...`;
    case 'generating':
      return `${prefix}正在生成批改结果和建议...`;
    case 'completed':
      return `${prefix}批改完成`;
    default:
      return `${prefix}正在处理...`;
  }
};

const ProgressDisplay: React.FC<ProgressDisplayProps> = ({ 
  percent = 0, 
  stage, 
  message,
  studentName 
}) => {
  const stageName = getStageName(stage);
  const description = message || getStageDescription(stage, studentName);
  
  return (
    <Space direction="vertical" size={4} style={{ width: '100%' }}>
      <Space size={4}>
        <LoadingOutlined spin />
        <Text type="secondary" style={{ fontSize: 12 }}>
          {stageName}
        </Text>
      </Space>
      <Progress 
        percent={percent} 
        size="small" 
        status="active"
        strokeColor={{
          '0%': '#108ee9',
          '100%': '#87d068',
        }}
      />
      <Text type="secondary" style={{ fontSize: 11 }}>
        {description}
      </Text>
    </Space>
  );
};

export default ProgressDisplay;